<template>
  <van-pull-refresh v-model="isLoading" success-text="刷新成功" @refresh="onRefresh" v-swipeup="(e) => vueTouch('上滑', e)">
    <div class="attention">
      <!-- <div class="commonBg"></div> -->
      <div class="myAttention" style="display: none">
        <div class="clear">
          <p class="fl">我的关注</p>
          <p class="more">更多></p>
        </div>
        <van-grid square :border="false" :column-num="5" :gutter="10">
          <van-grid-item v-for="item in myattention" :key="item.memberNickName">
            <!-- <van-image src="@/assets/img/tdj-icon.png" /> -->
            <!-- <van-image src="https://img01.yzcdn.cn/vant/apple-1.jpg" /> -->
            <img src="@/assets/img/tdj-icon.png" alt="" />
            <p>{{ item.memberNickName }}</p>
          </van-grid-item>
        </van-grid>
      </div>
      <!-- 可能感兴趣的人 -->
      <div class="mayBeInterested" v-show="interested && followsList.length > 0">
        <h2>你可能感兴趣的人</h2>
        <div class="list_wrap">
          <ul class="list clear">
            <li v-for="item in followsList" :key="item.id" @click="goUserPage(item.id)">
              <div class="tx" :class="item.isOfficial == 1 ? 'on' : ''">
                <img :src="item.avatar" @error="defImg()" alt="" />
              </div>
              <p>{{ item.nick_name }}</p>
              <span class="follow" @click.stop="focusClick(item)">关注</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="listPage_emptyicon" v-if="topicsList.length == 0">
        <div class="listPage_emptyicon_icon"></div>
        <div class="listPage_emptyicon_text">快关注感兴趣的人吧</div>
      </div>
      <!-- 已發布帖子 -->
      <van-list v-show="topicsList.length != 0" v-model="listInit.loading" :finished="listInit.finished"
        finished-text="没有更多了" :immediate-check="false" @load="onLoad">
        <card v-for="item in topicsList" :key="item.id" :cardData="item" @firstLoad="firstLoad"></card>
      </van-list>
    </div>
  </van-pull-refresh>
</template>

<script>
import Vue from 'vue';
import get from '@/api/get';
import { Grid, GridItem, Dialog, list, Toast } from 'vant';
import card from '../../card';
Vue.use(Grid);
Vue.use(GridItem);
export default {
  name: 'attention',
  components: { card },
  data() {
    return {
      defaultImg: this.$store.state.gameType != 1 ? "https://media.tentree-games.com/media/pictures/community/img/header.webp" :
        "https://media.zlongame.com/media/pictures/cn/community/img/lzg_header.png",
      nick_name: '',
      memberName: '',
      name: 'attention',
      myattention: [{ name: '玩家名字0' }, { name: '玩家名字1' }],
      followsList: [], //推荐
      interested: false,
      listInit: {
        loading: false,
        finished: false,
        pageNo: 1,
        pageSize: 10
      },
      isLoading: false,
      tipTxtShow: false
    };
  },
  props: ['topicsList'],
  async mounted() {
    if (this.$store.state.token == '') {
      const promise = new Promise((resolve) => {
        this.resolveHander = resolve;
      });
      await promise;
    }
    this.init();
    this.getFollows();
  },
  watch: {
    '$store.state.token'(token) {
      if (token != '') {
        this.resolveHander && this.resolveHander();
      }
    },
    topicsList(n, o) {
      if (n.length == 0) {
        this.tipTxtShow = true;
      } else {
        this.tipTxtShow = false;
      }
    }
  },
  methods: {
    init() {
      get.getfollowsList().then((res) => {
        let _data = res.data;
        if (_data.code == 0) {
          this.followsList = _data.data;
        } else {
          this.errorMessage(_data);
        }
      });
      if (!this.topicsList.length) {
        this.tipTxtShow = true;
      }
    },
    defImg() {
      //图片错误展示默认图片
      let img = event.srcElement;
      img.src = this.defaultImg;
      img.onerror = null; //防止闪图
    },
    //去用户主页
    goUserPage(id) {
      this.$router.push({ name: 'otherHome', query: { id: id } });
    },
    //获取关注列表
    getFollows() {
      if (this.$store.state.token != '' && this.$store.state.loginStatus == 1) {
        get.getFollows().then((res) => {
          let _data = res.data.data;
          if (!_data.length) {
            this.interested = true;
          } else {
            this.interested = true;
          }
        });
      }
    },
    //关注&&取消关注
    focusClick(item) {
      get.follow(item.id).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          item.isFollow = !item.isFollow;
          // if (item.isFollow) {
          //   Toast("关注成功");
          // } else {
          //   Toast("已取消关注");
          // }
          this.init();
          this.firstLoad();
        } else {
          this.errorMessage(data);
        }
      });
    },
    // 首次加载
    firstLoad() {
      this.listInit.pageNo = 1;
      this.listInit.refresh = true;
      this.tipTxtShow = false;
      this.$emit('tabClick', 0, '关注', this.listInit);
    },
    // 下拉加载
    onLoad() {
      let _this = this;
      this.listInit.pageNo++;
      this.listInit.refresh = false;
      this.tipTxtShow = false;
      console.log(this.listInit);
      setTimeout(() => {
        this.$emit('tabClick', 0, '关注', this.listInit, function (newList) {
          // 加载状态结束
          _this.listInit.loading = false;
          // 数据全部加载完成
          if (newList.length < 10) {
            _this.listInit.finished = true;
            _this.listInit.pageNo--;
          }
        });
      }, 1000);
    },
    vueTouch(text, e) {
      this.listInit.finished = false;
      this.listInit.loading = true;
      setTimeout(() => {
        this.onLoad();
      }, 1000);
    },
    // 下拉刷新
    onRefresh() {
      var _this = this;
      _this.listInit.pageNo = 1;
      setTimeout(() => {
        this.isLoading = false;
        this.$emit('tabClick', 0, '关注', this.listInit, '', true);
        // Toast('刷新成功');
      }, 1000);
    },
    errorMessage(data) {
      let code = data.code;
      if (code != 2050) {
        let voteErr = _code.code.vote;
        let msg = voteErr[code] ? voteErr[code] : voteErr['other'] + code;
        Toast(msg);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
